<template>
  <div>
    <el-card>
      <el-page-header
        :content="title"
        style="margin-bottom: 30px;"
        @back="goBack"
      />
    </el-card>

    <el-card style="margin-top: 10px">
      <el-table
        :data="list"
        style="width: 100%"
        border
        stripe
        :header-cell-style="rowClass"
      >
        <el-table-column prop="id" width="60" label="编号" />
        <el-table-column prop="userName" label="姓名" />
        <el-table-column prop="userId" label="UID" />
        <el-table-column prop="userAvatar" label="头像">
          <template slot-scope="{ row }">
            <el-image
              style="width: 80px"
              :src="row.userAvatar"
              :preview-src-list="[row.userAvatar]"
            />
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="领取时间" />
        <el-table-column prop="status" label="使用情况">
          <template slot-scope="{ row }">
            <el-tag :type="row.status * 1 ? 'warning' : 'info'">
              {{ row.status * 1 ? '已使用' : '未使用' }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="search.page"
        background
        :page-sizes="[3, 5, 10, 15]"
        :page-size="search.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"
      />
    </el-card>
  </div>
</template>

<script>
import list from '/src/mixin/list.js'
export default {
  mixins: [list],
  data() {
    return {
      search: {
        page: 1,
        pageSize: 10,
      },
      form: {},
    }
  },
  methods: {
    async getlist(val) {
      if (!this.$route.query.id) {
        return
      }
      const form = val || this.search

      const { data: res } = await this.$http.get(
        '/admin/CooperationPropCoupon/getReceiveList',
        {
          params: {
            ...form,
            id: this.$route.query.id,
          },
        }
      )
      if (res.errorCode == 200) {
        this.title =
          (res.data.coupon && res.data.coupon.title) ||
          '领取列表'
        this.list = res.data.list || []
        this.total = res.data.totalCount || 0
      }
    },
    handleCurrentChange(e) {
      this.search.page = e
      this.form.page = e
      this.getlist(this.form)
    },
    subimt() {
      this.form = { ...this.search }
      this.getlist()
    },
  },
  created() {
    this.getlist()
    this.form = { ...this.search }
  },
}
</script>

<style lang="less" scoped></style>
